import React, { Component} from 'react'
import PropTypes from 'prop-types';
import { Card , Button} from 'react-bootstrap';

var moment = require('moment');

class InvoiceSync extends React.Component {
  constructor (props) {
    super(props)
    this.sync = this.sync.bind(this);
  }
  
  sync(){
      this.props.syncWarehouses('');
  };

  render() {
    const { lastSynchronized, isSynching } = this.props;

    var lastUpdated = 'Never Go to Settings Page to initiate initial Sync'
    if( lastSynchronized !== '' && lastSynchronized !== null){
      lastUpdated = moment(lastSynchronized, moment.ISO_8601).format('DD-MM-YYYY');
    }
    if( isSynching ){
      return(
        <Card><b>Last Synchronized:</b> updating .. <div className="loader">Loading...</div></Card>
    )

    }else{
      return (
        <Card><b>Last Synchronized:</b> {lastUpdated} <Button
            bsSize="xsmall"
            variant="primary"
            onClick={this.sync}>Update
          </Button></Card>

      )
    }
  }
}

InvoiceSync.propTypes = {
  lastSynchronized: PropTypes.string
}


export default InvoiceSync;
